module.exports = __webpack_public_path__ + "static/media/card-email-mobile-es.5d0a56bd.png";